<template>
  <div>
    <CRow v-if="isActive">
      <CCol md="12" class="text-right mb-2">
        <CButton color="info" size="sm" @click="openCreate">Programar envio</CButton>
      </CCol>

      <CCol md="12">
        <ScheduledSendsTable
          :items="items"
          @show-detail="showDetail"
          @edit="openEdit"
          @cancel="cancelItem"
          @execute-now="executeNow"
        />
      </CCol>
    </CRow>

    <ScheduleSendModal ref="scheduleModal" @saved="handleScheduleSaved" />
    <ScheduledSendDetailModal ref="scheduledSendDetailModal" />
    <ConfirmModal ref="confirmModal" @confirm="confirmAction" />
  </div>
</template>

<script>
import wsScheduled from '@/services/events_scheduled_sends'
import wsTables from '@/services/events_tables'
import ScheduledSendsTable from '@/components/events/event/detail/scheduled/ScheduledSendsTable.vue'
import ScheduleSendModal from '@/components/events/event/detail/scheduled/ScheduleSendModal.vue'
import ScheduledSendDetailModal from '@/components/events/event/detail/scheduled/ScheduledSendDetailModal.vue'
import ConfirmModal from '@/components/global/ConfirmModal.vue'
import useMessageTypeLabel from '@/composables/useMessageTypeLabel'
import store from '@/store'

const { getMessageTypeLabel } = useMessageTypeLabel()

export default {
  name: 'ScheduledSendsModule',
  components: { ScheduledSendsTable, ScheduleSendModal, ScheduledSendDetailModal, ConfirmModal },
  props: {
    event: { type: Object, required: true },
    isActive: { type: Boolean, default: false }
  },
  data() {
    return {
      eventId: this.$route.params.id,
      hasTables: 0,
      items: [],
      pendingActionType: '',
      pendingActionItem: null
    }
  },
  mounted() {
    this.loadTables()
    this.loadItems()
  },
  methods: {
    openCreateFromOutside(messageType = null) {
      this.openCreate(messageType)
    },
    async handleScheduleSaved() {
      await this.loadItems()
      this.$emit('saved-scheduled-send')
    },
    async loadTables() {
      const response = await wsTables.get(this.eventId)
      if (response.type === 'success') {
        this.hasTables = (response.data || []).length
      }
    },
    async loadItems() {
      this.loading()
      const response = await wsScheduled.get(this.eventId)
      if (response.type === 'success') {
        this.items = response.data
      }
      this.loaded()
    },
    openCreate(messageType = null) {
      this.$refs.scheduleModal.show({
        eventId: this.eventId,
        event: this.event,
        hasTables: this.hasTables,
        presetMessageType: messageType,
      })
    },
    openEdit(item) {
      this.$refs.scheduleModal.show({
        eventId: this.eventId,
        event: this.event,
        hasTables: this.hasTables,
        item,
      })
    },
    async cancelItem(item) {
      this.pendingActionType = 'cancel'
      this.pendingActionItem = item
      this.$refs.confirmModal.show(
        'dark',
        'Cancelar envio programado',
        'Se cancelara este envio programado.',
        `<strong>Tipo:</strong> ${this.getTypeLabel(item.message_type)}<br/><strong>Fecha:</strong> ${this.formatDate(item.scheduled_date)}<br/><strong>Hora:</strong> ${this.formatTime(item.scheduled_time)}`
      )
    },
    async executeNow(item) {
      this.pendingActionType = 'execute'
      this.pendingActionItem = item
      this.$refs.confirmModal.show(
        'dark',
        'Ejecutar envio programado',
        'Se ejecutara inmediatamente este envio programado.',
        `<strong>Tipo:</strong> ${this.getTypeLabel(item.message_type)}<br/><strong>Fecha:</strong> ${this.formatDate(item.scheduled_date)}<br/><strong>Hora:</strong> ${this.formatTime(item.scheduled_time)}`
      )
    },
    async showDetail(item) {
      this.loading()
      const response = await wsScheduled.show(this.eventId, item.id)
      this.loaded()

      if (response.type === 'success') {
        const payload = response.data || {}
        const schedule = payload.schedule || {}
        const batchId = schedule.execution_request_id || null
        this.$refs.scheduledSendDetailModal.showDetail(schedule, batchId)
      }
    },
    async confirmAction() {
      if (!this.pendingActionItem || !this.pendingActionType) {
        return
      }

      this.loading()
      let response = { type: 'error', message: 'No se pudo ejecutar la accion.' }

      if (this.pendingActionType === 'cancel') {
        response = await wsScheduled.cancel(this.eventId, this.pendingActionItem.id)
      }

      if (this.pendingActionType === 'execute') {
        response = await wsScheduled.executeNow(this.eventId, this.pendingActionItem.id)
      }

      this.loaded()
      this.showToast(response.type, response.message)

      this.pendingActionItem = null
      this.pendingActionType = ''

      if (response.type === 'success') {
        this.loadItems()
      }
    },
    getTypeLabel(type) {
      return getMessageTypeLabel(type)
    },
    getStatusLabel(status) {
      switch (status) {
        case 'scheduled': return 'Programado'
        case 'executing': return 'Ejecutando'
        case 'queued': return 'En cola'
        case 'executed': return 'Ejecutado'
        case 'cancelled': return 'Cancelado'
        case 'failed': return 'Error'
        default: return status
      }
    },
    formatTime(value) {
      if (!value) return ''
      return String(value).substring(0, 5)
    },
    formatDate(value) {
      if (!value) return ''
      return String(value).substring(0, 10)
    },
    showToast(type, message) { store.commit('toast', { color: type, message }) },
    loading() { store.commit('loading') },
    loaded() { store.commit('loaded') }
  }
}
</script>
